import * as React from "react";

export const errorMessage = field => {
    const { meta } = field;
    return (
        <div style={{ position: "relative" }}>
            {meta.error && meta.touched && <span className="field-error">{meta.error}</span>}
        </div>
    );
};

export const submitFailureGotoErrors = function submitFailureGotoErrors(errorFieldList) {
    if (global.canUseDOM) {
        const fields = [];
        for (const key in errorFieldList) {
            if (errorFieldList[key]) {
                fields.push(key);
            }
        }

        const input = document.querySelector(`[name="${fields[0]}"]`);
        if (input) {
            window.scrollTo({ top: input.offsetTop, behavior: "smooth" });
        }
    }
};

export const validateEmail = value => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);
};
